/* Libroide: alinea titulos, disponibilidad y precios por fila real de coleccion.
   No fija 3 lineas: usa solo la altura maxima necesaria en cada fila. */
(() => {
  if (window.__lirogoRowPrices) return;
  window.__lirogoRowPrices = true;
  const selector = '#collection > li.product-card';
  let scheduled = false;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      align();
    });
  }

  function align() {
    const grid = document.querySelector('#collection');
    if (!grid) return;
    const cards = [...grid.querySelectorAll(':scope > li.product-card')].filter(el => el.getClientRects().length);
    const items = cards.map(card => {
      const title = card.querySelector(':scope > div > h3');
      const stock = card.querySelector(':scope > div > p.list-hide');
      const price = card.querySelector(':scope > div > p.price.s1pr');
      return {card, title, stock, price};
    }).filter(x => x.title && x.price);

    // Reset to intrinsic heights before measuring each row.
    for (const x of items) {
      x.title.style.removeProperty('min-height');
      if (x.stock) x.stock.style.removeProperty('min-height');
    }
    const rows = [];
    for (const x of items) {
      const top = x.card.getBoundingClientRect().top;
      let row = rows.find(r => Math.abs(r.top - top) < 3);
      if (!row) rows.push(row = {top, items: []});
      row.items.push(x);
    }
    for (const row of rows) {
      const maxTitle = Math.max(...row.items.map(x => x.title.getBoundingClientRect().height));
      const maxStock = Math.max(...row.items.map(x => x.stock ? x.stock.getBoundingClientRect().height : 0));
      for (const x of row.items) {
        x.title.style.minHeight = `${Math.ceil(maxTitle)}px`;
        if (x.stock) x.stock.style.minHeight = `${Math.ceil(maxStock)}px`;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  window.addEventListener('resize', schedule, {passive:true});
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:select', schedule);
  const mo = new MutationObserver(records => {
    if (records.some(r => r.addedNodes.length || r.removedNodes.length)) schedule();
  });
  mo.observe(document.body, {childList:true, subtree:true});
  if (document.readyState !== 'loading') schedule();
})();